import React, { useEffect, useState } from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import useTitle from "../components/Title";
// import HomeArticles from "../components/homeArticles";
import HomeAutomotive from "../components/homeAutomotive";
import HomeSports from "../components/homeSports";
import HomeMusic from "../components/homeMusic";


const Home  = () => {
  useTitle("- Home");

   const [, setTheme] = useState("light");

  // Read theme from localStorage on first render and listen for changes
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);

    // Listen for storage changes (from navbar or other components)
    const handleStorageChange = (e) => {
      if (e.key === "theme") {
        setTheme(e.newValue || "light");
      }
    };
    
    // Also watch for direct HTML attribute changes
    const observer = new MutationObserver(() => {
      const currentTheme = document.documentElement.dataset.theme || "light";
      setTheme(currentTheme);
    });

    window.addEventListener("storage", handleStorageChange);
    observer.observe(document.documentElement, { attributes: true });

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      observer.disconnect();
    };
  }, []);
    

  return (
  <div className="">
    <Navbar />
      <div className="App-header">

        <div className="container-md pb-5">

              <div className="row align-items-center"> 
                <div className="col-lg-6">
                  <h1 className="mt-5 event-heading-start">We Have Events.</h1>
                  <p className="event-sub-text mb-5">
                     From car shows to festivals and way more on the way, there's something for everyone. Check out what's happening and join in, it's all here!
                  </p>
                </div>
                <div className="col-lg-6 d-none d-lg-flex justify-content-center position-relative hero-circles">
                  <div className="circle-image circle-car"></div>
                  <div className="circle-image circle-sports"></div>
                  <div className="circle-image circle-music"></div>
                </div>
              </div>

              <div className="row mt-5"> 
                <div className="home-card-section"> 
                  <div className="home-card">
                    <Link to="/Automotive" className="home-card-link"> 
                     <div className="home-card-content"> 
                        <p className="home-card-icon"> <i className="bi bi-car-front-fill"></i> </p>
                        <p className="home-card-text">Automotive</p>
                        <p className="home-card-desc mb-0">
                          Discover and explore exciting automotive events.
                        </p>
                      </div>
                    </Link>
                  </div>
                    
                  <div className="home-card">
                    <Link to="/Sports" className="home-card-link"> 
                     <div className="home-card-content"> 
                       <p className="home-card-icon"> <i className="bi bi-duffle"></i> </p>
                        <p className="home-card-text">Sports</p>
                       <p className="home-card-desc mb-0">
                          Explore all your favorite sports activities.
                        </p>

                      </div>
                    </Link>
                  </div>

                  <div className="home-card">
                    <Link to="/Music" className="home-card-link"> 
                     <div className="home-card-content"> 
                       <p className="home-card-icon"> <i className="bi bi-music-note-beamed"></i> </p>
                        <p className="home-card-text">Music</p>
                        <p className="home-card-desc mb-0">
                          Dance and Discover amazing music events.
                        </p>
                      </div>
                    </Link>
                  </div>

                </div>
              </div>

        </div>


 <div className="container-secondary my-5">

            <HomeAutomotive/>
    
            <HomeSports/>

            <HomeMusic/>

</div>

        {/* <div className="container-md py-5">
           <div className="row">
              <div className="col-md-10 col-sm-12 text-start">
                <HomeArticles/>
              </div>
           </div>
        </div> */}


      </div>
    <Footer />
  </div>
  );
};


export default Home;